import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ResultsView.css';
import BadgesAwardedPrompt from './BadgesAwardedPrompt';
import LevelProgress from './LevelProgress';
import EarnedCredits from './EarnedCredits';
import BadgesUnlocked from './BadgesUnlocked';
import CertificateActions from './CertificateActions';
import KippyEmotions from './KippyEmotions';

const ResultsView = ({ results, topicName, onClickReview }) => {
    const navigate = useNavigate();
    const percentage = Math.round((results.score / results.total) * 100);

    console.log("ResultsView props:", { percentage });

    const getEmotion = (percentage) => {
        if (percentage >= 80) return 'super-happy';
        if (percentage >= 50) return 'happy';
        if (percentage >= 30) return 'neutral';
        if (percentage >= 10) return 'sad';
        return 'super-sad';
    };

    return (
        <div className="results-container">
            <KippyEmotions emotion={getEmotion(percentage)} size="100px" />

            <h2 className="results-title">Quiz Completed!</h2>

            <div className="score-circle-wrapper">
                <div className="score-circle">
                    <span className="score-number">{results.score}</span>
                    <span className="score-total">/ {results.total}</span>
                </div>
                <div className="percentage-badge">{percentage}% Correct</div>
            </div>

            <div className="feedback-message">
                {percentage >= 80 ? "Excellent work! You've mastered this!" :
                    percentage >= 50 ? "Good job! Keep practicing to get even better." :
                        "Don't give up! Review the topic and try again."}
            </div>

            <CertificateActions attemptId={results.attemptId} percentage={percentage}/>

            <div className="stat-card">
                <BadgesUnlocked count={results.badgesAwarded.length} />
                <LevelProgress oldLevel={results.levels.old} newLevel={results.levels.new} />
                <EarnedCredits credits={results.creditsEarned} />
            </div>
            <BadgesAwardedPrompt badgesAwarded={results.badgesAwarded} />
            <div className="results-actions">
                <button
                    onClick={onClickReview}
                    className="home-btn"
                >
                    Review
                </button>
                <button
                    onClick={() => navigate('/student/home')}
                    className="home-btn"
                >
                    Back to Dashboard
                </button>
            </div>
        </div>
    );
};

export default ResultsView;